import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { repositorySign } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";

const DocTypeDeleteView = ({
    ids,
    onClose,
    onSearch,
}: DocTypeDeleteViewProps) => {
    const handleDeleteDocType = async () => {
        let url =
            "https://apis-pos-dev.hacom.vn//api-sign/api/v1/TblDocType/delete";
        const response = await repositorySign.post<MessageResponse<boolean>>(
            url,
            ids
        );
        if (response && response.success) {
            onClose((prev: any) => !prev);
            NotificationExtension.Success("Xóa loại tài liệu thành công !");
            modals.closeAll();
        } else {
            NotificationExtension.Fails("Xóa loại tài liệu thất bại !");
        }
        modals.closeAll();
        onSearch();
    };
    return (
        <>
            <div>
                <Text size="20px" mt={5}>
                    Bạn có chắc chắn muốn xóa loại đơn sau không?
                </Text>
                <Group justify="center" mt="lg">
                    <Button
                        type="button"
                        color="gray"
                        onClick={() => modals.closeAll()}
                        leftSection={<IconX size={18} />}
                    >
                        Hủy
                    </Button>
                    <Button
                        type="button"
                        color="red"
                        onClick={handleDeleteDocType}
                        leftSection={<IconCheck size={18} />}
                    >
                        Xóa
                    </Button>
                </Group>
            </div>
        </>
    );
};

type DocTypeDeleteViewProps = {
    ids: (number | string)[];
    onClose: any;
    onSearch: () => void;
};
export default DocTypeDeleteView;
